
import WidgetDefaultNuxt from '../default/nuxt.vue';

export default {
  name: 'WidgetFrameNuxt',
  extends: WidgetDefaultNuxt,
  data() {
    let isPrimaryFrame = this.file.pureInfo.primaryFrameId === this.values.id;
    return {
      isPrimaryFrame,
      forceVisible: isPrimaryFrame ? 0 : -1,
      pageIndex: 0,
      pages: null,
      staticEvent:
        !!this.values.static?.event && this.file.pureInfo.children.length < 2,
    };
  },
  computed: {
    rootScreenClass() {
      return [
        'widget-frame',
        {
          'widget-frame-popup': !this.isPrimaryFrame,
          ...this.classes,
        },
      ];
    },
    frameStyles() {
      let styles = {};
      if (!this.isPrimaryFrame && this.pageIndex > 0) {
        styles = {
          'z-index': this.pageIndex + 999,
        };
      }
      return styles;
    },
    isNeedEdgeEvent() {
      // 只有有半透明背景的页面才会补充自动关闭的图层
      if (this.values.isNeedEdgeEvent) {
        return !this.isPrimaryFrame;
      }
      return false;
    },
  },
  mounted() {
    if (this.isPrimaryFrame) {
      this.pages = new Set();
      // 主页才会监听
      // 静态和无子页的情况不需要监听
      if (!this.staticEvent) {
        this.rocketOn('rocket:system:openPage', false, this.handleOpenPage);
        this.rocketOn('rocket:system:jumpPage', false, this.handleShowPage);
        this.rocketOn('rocket:system:closePage', false, this.handleClosePage);
      }
    }
  },
  beforeDestroy() {
    if (this.isPrimaryFrame && !this.staticEvent) {
      this.rocketOff('rocket:system:openPage', false, this.handleOpenPage);
      this.rocketOff('rocket:system:jumpPage', false, this.handleShowPage);
      this.rocketOff('rocket:system:closePage', false, this.handleClosePage);
    }
  },
  methods: {
    closePage() {
      this.$bus.$emit('rocket:system:closePage', {
        key: this.values.id,
      });
    },
    handleShow(zIndex) {
      this.forceVisible = 1;
      this.pageIndex = zIndex;
    },
    hidePage(payload) {
      let key = payload.key;
      if (!key || !this.pages || !this.pages.has(key)) return;
      window.moo.triggerNodeEvent('rocket:system:hide', payload);
      this.pages.delete(key);
      if (!this.pages.size) this.pageIndex = 0;
    },
    // 关闭指定弹窗以外的所有弹窗
    handleCloseAllPages(excludeKey) {
      if (!this.pages || !this.pages.size) return;
      this.pages.forEach((v) => {
        if (v !== excludeKey) this.hidePage({ key: v });
      });
    },
    // 返回主页
    handleBackHome() {
      if (!this.pages.size) return;
      this.handleCloseAllPages();
      this.handlePageChange();
    },
    handleOpenPage(payload) {
      this.handleShowPage(payload, true);
    },
    handleShowPage(payload, keep = false) {
      const key = payload?.key;
      const isBackHome = key === this.id;
      if (!key) return;
      if (isBackHome) {
        if (keep) return;
        this.handleBackHome();
        return;
      }
      if (!keep) this.handleCloseAllPages(key); // 不保持时关闭其它弹窗
      if (this.pages.has(key) && this.pages.size > 1) {
        const arr = Array.from(this.pages);
        let k = arr.pop();
        if (k === key) return; // 判断是否是最上层弹窗
        this.pages.delete(key); // 需要先移除，再添加，确保在列表最后
      }
      window.moo.triggerNodeEvent(
        'rocket:system:show',
        payload,
        this.pageIndex
      );
      this.pages.add(key);
      this.pageIndex++;
      this.handlePageChange();
      this.$bus.$emit('rocket:system:openPage:' + payload.key, {
        key: this.values.id,
      });
    },
    // 关闭某个页面
    handleClosePage(payload) {
      this.hidePage(payload);
      this.handlePageChange();
      this.$bus.$emit('rocket:system:closePage:' + payload.key, {
        key: this.values.id,
      });
    },
    handlePageChange() {
      this.rocketEmit('rocket:system:pageChange', false, [...this.pages]);
    },
  },
};
